import Header from '../components/Header';
import Footer from '../components/Footer';
import { useEffect } from 'react';

const Disclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />

      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-gray-900">Website Disclaimer</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
            <p>Welcome to our website.</p>

            <p>
              If you continue to browse and use this website you are agreeing to comply with and be bound by the following disclaimer, together with our terms and conditions of use.
            </p>

            <p>
              The information contained in this website is for general information purposes only and is provided by www.originalbull.com. While we endeavour to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk. You need to make your own enquiries to determine if the information or products are appropriate for your intended use.
            </p>

            <p>
              In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.
            </p>

            <p>
              Through this website you may be able to link to other websites which are not under the control of www.originalbull.com. We have no control over the nature, content and availability of those websites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
            </p>

            <p>
              Every effort is made to keep the website up and running smoothly. However, www.originalbull.com takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-900">COPYRIGHT NOTICE</h2>

            <p>
              This website and its contents are the copyright of Original Bull Pty Ltd – © 2025. All rights reserved.
            </p>

            <p>
              Any redistribution or reproduction of part or all of the contents in any form is prohibited other than the following. You may print or download contents to a local hard disk for your personal and non-commercial use only. You may copy some extracts only to individual third parties for their personal use, but only if you acknowledge the website as the source of the material.
            </p>

            <p>
              You may not, except with our express written permission, distribute or commercially exploit the content. You may not transmit it or store it on any other website or other form of electronic retrieval system.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Disclaimer;
